import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { BookmarkService, BookmarkVisibilityItem, BookmarkVisibilityValue, MapBookmark } from 'app/services/bookmark.service';
import { TableColumn } from 'app/services/common-table.service';
import { FloatPopupService } from 'app/services/float-popup.service';
import { MainDataMapService } from 'app/services/main-data-map.service';
import { UserService } from 'app/services/user.service';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-feat-map-bookmark-manager',
  templateUrl: './feat-map-bookmark-manager.component.html',
  styleUrls: ['./feat-map-bookmark-manager.component.css']
})
export class FeatMapBookmarkManagerComponent implements OnInit, AfterViewInit, OnDestroy {

	// @ViewChild('searchCellTempl', { static: false }) searchCellTempl: TemplateRef<any>;
	// @ViewChild('deleteCellTempl', { static: false }) deleteCellTempl: TemplateRef<any>;

	bookmarkName: string;
	bookmarkVisibilities: BookmarkVisibilityItem[];
	bookmarkVisib: BookmarkVisibilityValue;
	bookmarkDesc: string;
	bookmarkBboxStr: String;

	bookmarkList: MapBookmark[] = [];
	columns: TableColumn[];
	userName: string;

	isAdding: boolean;
	deletingId: number;

	private mapSub: Subscription;
	constructor(
		private toastr: ToastrService,
		private bookmarkService: BookmarkService,
		private floatPopupService: FloatPopupService,
		private mapService: MainDataMapService,
		private userService: UserService
	) { }

	close() {
		this.floatPopupService.closePopup(FeatMapBookmarkManagerComponent);
	}
	goToBookmark(bookmark: MapBookmark) {
		this.mapService.map.zoomToExtent(bookmark.bbox, {
			padding: [0, 0, 0, 0]
		})
	}
	async getBookmarks() {
		const bookmarks = await this.bookmarkService.getMapBookmarks('BBOX');
		this.bookmarkList = bookmarks;
	}
	async addBookmark() {
		this.isAdding = true;
		try {
			const bbox = this.mapService.map.olMap.getView().calculateExtent();
			await this.bookmarkService.addMapBookmarks(this.bookmarkName, this.bookmarkDesc, this.bookmarkVisib, 'BBOX', bbox);
			this.toastr.success('Successfully added');
			this.bookmarkName = null;
			this.bookmarkDesc = null;
			await this.getBookmarks();
		} catch (err) {
			console.log(err)
		}
		this.isAdding = false;
	}
	async deleteBookmark(bookmark: MapBookmark) {
		this.deletingId = bookmark.id;
		try {
			await this.bookmarkService.deleteMapBookmark(bookmark.id);
			this.toastr.success('Successfully deleted');
			await this.getBookmarks();
		} catch (err) {
			console.log(err)
		}
		this.deletingId = null;
	}
	async ngOnInit() {
		this.columns = [
			{
				prop: 'search',
				name: ' ',
				info: {
					fixedCellClass: []
				},
				// cellTemplate: this.searchCellTempl,
				width: 30
			},
			{
				prop: 'name',
				name: 'NAME',
				info: {
					fixedCellClass: []
				}
			},
			// {
			// 	prop: 'desc',
			// 	name: 'Description',
			// 	info: {
			// 		fixedCellClass: []
			// 	}
			// },
			{
				prop: 'ownerDisplay',
				name: 'OWNER',
				info: {
					fixedCellClass: []
				}
			},
			{
				prop: 'visibility',
				name: 'VISIBILITY',
				info: {
					fixedCellClass: []
				}
			},
			{
				prop: 'delete',
				name: ' ',
				info: {
					fixedCellClass: []
				},
				// cellTemplate: this.deleteCellTempl,
				width: 30
			}
		];
		this.bookmarkVisibilities = this.bookmarkService.bookmarkVisibilities;
		this.bookmarkVisib = this.bookmarkVisibilities[0].value;
		this.userName = this.userService.getUserInfo().userEmail;
		await this.getBookmarks();
	}
	ngAfterViewInit(): void {
		this.bookmarkBboxStr = JSON.stringify(this.mapService.map.olMap.getView().calculateExtent());
		this.mapSub = this.mapService.mapMoveendSubject.subscribe(() => {
			this.bookmarkBboxStr = JSON.stringify(this.mapService.map.olMap.getView().calculateExtent());
		});
	}
	ngOnDestroy(): void {
		this.mapSub.unsubscribe();
	}

}
